<div class="tandc" style="margin: 50px 50px 0 50px">
  <div class="row" style="background-color: #FAFAFA; overflow: auto;height: 75vh;">
    <div class="small-12 medium-12 columns" style="padding-left: 25px;padding-top: 15px">
      <img src="https://static.taxplaniq.com/futurefirm/text_image.png" style="width: 118px;cursor: pointer;"/>
    </div>
    <div class="small-12 medium-12 columns" style="min-height:65vh;padding: 0 0 0 25px;margin-top: 20px;">
      <div class="terms-and-conditions">
        <div [innerHTML]="termsAndConditionsText"></div>
      </div>
    </div>
  </div>
  <div class="row" style="margin-top: 1rem;">
    <div class="small-12 medium-8">
      <div style="width: 250px;">
        <input type="text" placeholder="Enter your name here" style="font-weight: bold;" [(ngModel)]="termsAcceptedBy"/>
      </div>
    </div>
    <div class="small-12 medium-4 text-right">
      <button class="button small" [disabled]="!termsAcceptedBy" style="margin-right: 20px;" (click)="accept()">ACCEPT</button>
      <button class="button small" style="background: #F16459;margin-right: 20px;" (click)="decline()">DECLINE</button>
    </div>
  </div>
</div>

